import { createSelector } from '@reduxjs/toolkit';
import { User } from 'ducks/types/store-types';
import { RootState } from 'store';

const userSlice = (state: RootState) => state.user;

export const selectUser = createSelector([userSlice], (state): User => state);

export const selectAuthenticate = createSelector(
  [userSlice],
  (state) => state && state.private_key && state.public_key,
);
